import { Divider, Stack } from '@mui/material';
import { Details } from './components/details';
import { Filters } from './components/filters';
import { Refund } from './components/refund';
import { RegressiveDiscount } from './components/regressive-discount';
import { useBootstrapData } from '@/data/user/bootstrap-data';
import { Prices } from '@/packages/courses/components/prices';
import { useOffer } from '@/packages/courses/pages/details/context/offer';

export const NewSubscription = () => {
  const { bootstrap } = useBootstrapData();
  const { isFullIncluded, pricing, isLoading, isSingleOffer } = useOffer();

  const isEligibleForSubsidy =
    bootstrap?.plan?.subsidies_eligibility?.eligible_for_subsidies;

  return (
    <Stack gap={2}>
      {pricing && (
        <Prices
          isFullIncluded={isFullIncluded}
          pricing={pricing}
          isOfferFiltersLoading={isLoading}
          isSingleOffer={isSingleOffer}
        />
      )}
      <Divider />
      <RegressiveDiscount />
      {isEligibleForSubsidy && <Refund />}
      <Filters />
      <Details />
    </Stack>
  );
};
